import environment from "web/script/modules/environment";
import {
    CookieType,
    ThirdPartyScript,
} from "web/script/analytics/third_party_scripts/third-party-scripts";

interface HotjarData {
    q: any[];
}

interface HotjarSettings {
    hjid: string;
    hjsv: number;
}

declare global {
    interface Window {
        hj: HotjarData;
        _hjSettings: HotjarSettings;
    }
}

interface HotjarInterface extends ThirdPartyScript {
    hotjar: {
        id: string;
    };
}

export class Hotjar implements HotjarInterface {
    cookieType = "analytics" as CookieType;
    hotjar = environment.get("hotjar");

    async load(): Promise<void> {
        if (!this.hotjar) {
            return Promise.resolve();
        }

        return new Promise((resolve) => {
            (function (h, o, t, j, i): void {
                h.hj =
                    h.hj ||
                    function (): void {
                        // eslint-disable-next-line prefer-rest-params
                        (h.hj.q = h.hj.q || []).push(arguments);
                    };
                h._hjSettings = { hjid: i.id, hjsv: 6 };
                let a = o.getElementsByTagName("head")[0];
                let r = o.createElement("script");
                r.async = Boolean(1);
                r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
                r.addEventListener("load", () => {
                    resolve();
                });

                a.appendChild(r);
            })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=", this.hotjar);
        });
    }
}
